/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Listen_Any_SectionInputs */

const en_funnel_listen_any_section = /** @type {(inputs: Funnel_Listen_Any_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen to any section. Skip the rest.`)
};

const es_funnel_listen_any_section = /** @type {(inputs: Funnel_Listen_Any_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha la sección que quieras. Sáltate el resto.`)
};

/**
* | output |
* | --- |
* | "Listen to any section. Skip the rest." |
*
* @param {Funnel_Listen_Any_SectionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_listen_any_section = /** @type {((inputs?: Funnel_Listen_Any_SectionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Listen_Any_SectionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_listen_any_section(inputs)
	return en_funnel_listen_any_section(inputs)
});